// from https://material.io/design/environment/elevation.html#default-elevations
export enum ELEVATIONS {
  DIALOG = 24,
  FLOATING_ACTION_BUTTON = 12,
  MENUS_AND_SUB_MENUS = 8,
  FLOATING_NAVIGATION_BAR = 8,
  TEXT_BUTTON = 0,
}
